// extracted by mini-css-extract-plugin
export var discountCodeBubbleContainer = "_p9-0";
export var discountCodeInput = "_p9-1";